var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.91 9.312a2.353 2.353 0 0 0-.545 1.65v26.076c-.036.599.159 1.189.544 1.65l.083.082 14.652-14.593v-.342L10.992 9.229l-.083.083z",
    fill: "url(#a1ko9dk9wa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.493 29.046-4.849-4.869v-.342l4.849-4.88.106.059 5.806 3.289c1.656.931 1.656 2.464 0 3.407l-5.782 3.277-.13.059z",
    fill: "url(#87ekd4hz8b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.634 28.975 25.644 24 10.909 38.688c.696.61 1.73.64 2.46.07l17.277-9.783",
    fill: "url(#jp92x7nswc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.634 19.026 13.357 9.242a1.932 1.932 0 0 0-2.46.07L25.645 24l4.99-4.974z",
    fill: "url(#casbt5wtkd)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m30.492 28.87-17.135 9.724a1.98 1.98 0 0 1-2.365 0l-.083.083.083.082c.7.527 1.665.527 2.365 0l17.277-9.784-.142-.106z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M10.91 38.523a2.353 2.353 0 0 1-.545-1.65v.176c-.036.6.159 1.19.544 1.65l.083-.082-.083-.094zm25.495-12.99-5.913 3.335.107.107 5.806-3.277A2.063 2.063 0 0 0 37.588 24a2.194 2.194 0 0 1-1.183 1.532z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m13.357 9.406 23.048 13.062c.611.3 1.048.866 1.183 1.532a2.063 2.063 0 0 0-1.183-1.698L13.357 9.242c-1.655-.932-3.003-.154-3.003 1.732v.177c.035-1.898 1.36-2.676 3.003-1.745z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1ko9dk9wa",
    x1: 19.689,
    y1: 10.691,
    x2: 7.168,
    y2: 23.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "87ekd4hz8b",
    x1: 38.569,
    y1: 24,
    x2: 9.963,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jp92x7nswc",
    x1: 27.926,
    y1: 28.688,
    x2: 6.538,
    y2: 50.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "casbt5wtkd",
    x1: 7.196,
    y1: 7.04,
    x2: 16.743,
    y2: 16.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGooglePlay);
export default __webpack_public_path__ + "static/media/lightGooglePlay.45334cb2abbfaf1f7c8b4cf4b6b588cf.svg";
export { ForwardRef as ReactComponent };